import styled from '@emotion/styled';
import { Button, Typography } from '@robinpowered/ui-kit';

export const ResultRow = styled('div', {
  shouldForwardProp: (prop) => prop !== '$interactive',
})<{ $interactive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 6px;

  ${({ $interactive }) =>
    $interactive &&
    `
      cursor: pointer;

      &:hover,
      &:focus-visible {
        background: #f5f5f5;
        outline: none;
      }
    `}
`;

export const ResultAvatarWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const ResultIconTile = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 14px;
`;

export const ResultText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  line-height: 1.25;
`;

export const ResultName = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: anywhere;
`;

export const ResultSubtext = styled(Typography.Text)`
  color: rgba(0, 0, 0, 0.72);
  font-size: 12px;
`;

export const FilterButton = styled(Button)`
  min-height: 32px;
`;

export const FilterButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;
